import styled from 'styled-components';

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: ${({ theme }) => theme.cardBackgroundColor};
    width: 100%;
    padding: 10px 15px;
    border: 1px solid ${({ theme }) => theme.lightBorderColor};
    border-radius: var(--radius-lg);
    box-shadow: 0 1px 2px 0 hsl(var(--foreground) / 0.08);
    position: sticky;
    top: 0;
    z-index: 1; // necessary for the shadows
`;
